<template>
  <q-drawer
      :model-value="drawer"
      @update:model-value="$emit('update:drawer', $event)"
      class="mobile-menu"
      side="left"
      :width="320"
  >
    <q-scroll-area class="fit bg-primary">
      <div class="mobile-menu__account">
        <div class="row justify-end q-pa-xs">
          <icon-button
              icon="close"
              color="white"
              size="sm"
              aria-label="Sluit het mobiele menu"
              round
              @click="$emit('update:drawer', false)"
          />
        </div>
        <div class="column items-center q-mt-lg">
          <a :href="$route('auth.edit')">
            <common-avatar
                :user="currentUser"
                title="Instellingen"
                tabindex="0"
                size="64px"
                class="q-mb-sm"
            />
          </a>
          <div class="text-medium-bold">
            {{ $fullName(currentUser) }}
          </div>
        </div>
      </div>
      <search-bar class="q-ma-xs"/>
      <q-list>
        <nav-list-item
            v-if="$can('manage-projects')"
            label="Dashboard"
            route="dashboard"
        />
        <nav-list-item
            label="Projecten"
            route="project.index"
        />
        <nav-list-item
            v-if="$can('manage-rules')"
            label="Richtlijnen"
            route="rule.index"
        />
        <expansion-item
            v-if="hasManagementPermissions"
            label="Beheer"
            class="expand-button"
        >
          <q-list class="mobile-menu__submenu">
            <nav-list-item
                v-if="$can('manage-objects')"
                label="Inrichtingselementen"
                route="object.index"
            />
            <nav-list-item
                v-if="$can('manage-categories')"
                label="Categoriebeheer"
                route="category.index"
            />
            <nav-list-item
                v-if="$can('manage-phases')"
                label="Fasebeheer"
                route="phase.index"
            />
            <nav-list-item
                v-if="$can('manage-maps')"
                label="Kaartbeheer"
                route="mapgroup.index"
            />
            <nav-list-item
                v-if="$can('manage-users') || $can('manage-roles')"
                label="Gebruikersbeheer"
                route="user.index"
            />
            <nav-list-item
                v-if="$can('manage-users') || $can('manage-roles')"
                label="Rollenbeheer"
                route="user.role.index"
            />
          </q-list>
        </expansion-item>
        <nav-list-item
            v-else
            label="Inrichtingselementen"
            route="object.catalog"
        />
        <q-separator />
        <nav-list-item
            label="Berichten"
            route="auth.notifications"
        />
        <q-separator />
        <nav-list-item
            label="HIOR Support"
            target="_blank"
            href="http://hior.zendesk.com/"
        />
        <nav-list-item
            label="Handleiding"
            target="_blank"
            href="/assets/img/20220177%20HIOR%20uitleg%20redesign%20derden.pdf"
        />
        <q-separator />
        <nav-list-item
            label="Profiel"
            route="auth.edit"
        />
        <nav-list-item
            label="Instellingen"
            route="auth.notification.settings"
        />
        <nav-list-item
            label="Privacy statement"
            route="user_management.privacy-statement"
        />
        <q-separator />
        <nav-list-item
            label="Log uit"
            route="auth.logout"
        />
      </q-list>
    </q-scroll-area>
  </q-drawer>
</template>

<script>
export default {
  props: {
    drawer: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    hasManagementPermissions () {
      return this.$can('manage-objects') || this.$can('manage-categories') || this.$can('manage-phases') ||
          this.$can('manage-maps') || this.$can('manage-users') || this.$can('manage-roles')
    },
  },
}
</script>
